import { EKwikUIStarRatingSize } from "./star-rating.definitions";

export const DEFAULT_VALUES = {
  color: "var(--tui-primary)",
  disabled: false,
  focus: false,
  formControlName: "form_control_star_rating",
  icon: `<svg xml:space="preserve" width="48px" viewBox="0 0 48 48" version="1.1" id="_x3C_Layer_x3E_" height="48px" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns="http://www.w3.org/2000/svg"><g id="star_x2C__favorite"><path id="XMLID_2_" fill="transparent" stroke-width="3" stroke="var(--tui-rating-color)" d="M 23.3 38.6 l -10.9 5.7 c -1.2 0.6 -2.5 -0.4 -2.3 -1.6 l 2.1 -12.1 c 0.1 -0.5 -0.1 -1 -0.4 -1.4 l -8.8 -8.6 c -0.9 -0.9 -0.4 -2.5 0.9 -2.6 l 12.2 -1.8 c 0.5 -0.1 1 -0.4 1.2 -0.8 l 5.5 -11 c 0.6 -1.2 2.2 -1.2 2.8 0 l 5.5 11 c 0.2 0.5 0.7 0.8 1.2 0.8 l 12.2 1.8 c 1.3 0.2 1.8 1.8 0.9 2.6 l -8.8 8.6 c -0.4 0.4 -0.5 0.9 -0.4 1.4 l 2.1 12.1 c 0.2 1.3 -1.1 2.2 -2.3 1.6 l -10.9 -5.7 C 24.3 38.4 23.7 38.4 23.3 38.6 z"></path></g></svg>`,
  iconMarked: `<svg xml:space="preserve" width="48px" viewBox="0 0 48 48" version="1.1" id="_x3C_Layer_x3E_" height="48px" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns="http://www.w3.org/2000/svg"><g id="star_x2C__favorite"><path id="XMLID_2_" fill="var(--tui-rating-color)" stroke="var(--tui-rating-color)" stroke-width="3" d="M 23.3 38.6 l -10.9 5.7 c -1.2 0.6 -2.5 -0.4 -2.3 -1.6 l 2.1 -12.1 c 0.1 -0.5 -0.1 -1 -0.4 -1.4 l -8.8 -8.6 c -0.9 -0.9 -0.4 -2.5 0.9 -2.6 l 12.2 -1.8 c 0.5 -0.1 1 -0.4 1.2 -0.8 l 5.5 -11 c 0.6 -1.2 2.2 -1.2 2.8 0 l 5.5 11 c 0.2 0.5 0.7 0.8 1.2 0.8 l 12.2 1.8 c 1.3 0.2 1.8 1.8 0.9 2.6 l -8.8 8.6 c -0.4 0.4 -0.5 0.9 -0.4 1.4 l 2.1 12.1 c 0.2 1.3 -1.1 2.2 -2.3 1.6 l -10.9 -5.7 C 24.3 38.4 23.7 38.4 23.3 38.6 z"></path></g></svg>`,
  id: "star-rating",
  invalid: false,
  label: "Star Rating",
  max: 5,
  min: 0,
  placeholder: "Please provide feedback",
  size: EKwikUIStarRatingSize.M
};

export const VALIDATE_KEY_VALUES = {
  color: true,
  disabled: true,
  focus: true,
  formControlName: true,
  icon: true,
  iconMarked: true,
  id: true,
  invalid: true,
  label: true,
  max: true,
  min: true,
  placeholder: true,
  size: true
};
